import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, } from "react";
import { useLabelBoundingContainerRef } from "../providers/LabelBoundingContainerProvider";
import { ArrowDownBorder, HoverLabel, PlayerControlButton } from "../styles";
export const PlayerControlButtonComponent = ({ Icon, buttonRef, hoverText, label, forceLeft, forceBottom, interactive, ...props }) => {
    const containerRef = useLabelBoundingContainerRef();
    const labelRef = useRef(null);
    const localButtonRef = useRef(null);
    const [labelBelow, setLabelBelow] = useState(false);
    const [labelPosition, setLabelPosition] = useState("center");
    useEffect(() => {
        if (forceLeft && forceBottom) {
            setLabelPosition("left");
            setLabelBelow(true);
            return;
        }
        if (!containerRef)
            return;
        const container = containerRef.current;
        const hoverLabel = labelRef.current;
        const buttonEl = buttonRef?.current ?? localButtonRef.current;
        if (container && hoverLabel && buttonEl) {
            const containerRect = container.getBoundingClientRect();
            const labelRect = hoverLabel.getBoundingClientRect();
            const labelLeft = labelRect.left < containerRect.left;
            const labelRight = labelRect.right > containerRect.right;
            setLabelBelow(labelRect.top < containerRect.top);
            if (labelLeft) {
                setLabelPosition("left");
            }
            else if (labelRight) {
                setLabelPosition("right");
            }
        }
    }, [containerRef, hoverText, buttonRef, forceLeft, forceBottom]);
    return (_jsxs(PlayerControlButton, { ref: buttonRef ?? localButtonRef, tabIndex: interactive ? 0 : -1, "aria-hidden": !interactive, ...props, children: [Icon, label && _jsx("span", { children: label }), _jsxs(HoverLabel, { ref: labelRef, "$below": labelBelow, "$position": labelPosition, children: [hoverText, _jsx(ArrowDownBorder, { "$position": labelPosition, "$below": labelBelow })] })] }));
};
